var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "110px",
    height: "74px",
    viewBox: "-0.5 -0.5 110 74",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/141.0.0.0 Safari/537.36 Edg/141.0.0.0\" version=\"28.2.5\" scale=\"0.9\" border=\"0\"> <diagram name=\"P\\xE1gina-1\" id=\"Ari_Hm6nP6rEavx47Fki\"> <mxGraphModel dx=\"1273\" dy=\"570\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"827\" pageHeight=\"1169\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"2g2tDDkpjgB0YBOe56KS-1\" value=\"\" style=\"endArrow=none;html=1;rounded=0;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"400\" y=\"320\" as=\"sourcePoint\" /> <mxPoint x=\"440\" y=\"280\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"2g2tDDkpjgB0YBOe56KS-2\" value=\"\" style=\"endArrow=none;html=1;rounded=0;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"400\" y=\"320\" as=\"sourcePoint\" /> <mxPoint x=\"440\" y=\"360\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"2g2tDDkpjgB0YBOe56KS-3\" value=\"\" style=\"endArrow=none;html=1;rounded=0;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"520\" y=\"320\" as=\"sourcePoint\" /> <mxPoint x=\"480\" y=\"280\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"2g2tDDkpjgB0YBOe56KS-4\" value=\"\" style=\"endArrow=none;html=1;rounded=0;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"520\" y=\"320\" as=\"sourcePoint\" /> <mxPoint x=\"480\" y=\"360\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"2g2tDDkpjgB0YBOe56KS-5\" value=\"\" style=\"ellipse;whiteSpace=wrap;html=1;aspect=fixed;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"450\" y=\"280\" width=\"20\" height=\"20\" as=\"geometry\" /> </mxCell> <mxCell id=\"2g2tDDkpjgB0YBOe56KS-6\" value=\"\" style=\"ellipse;whiteSpace=wrap;html=1;aspect=fixed;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"450\" y=\"310\" width=\"20\" height=\"20\" as=\"geometry\" /> </mxCell> <mxCell id=\"2g2tDDkpjgB0YBOe56KS-8\" value=\"\" style=\"ellipse;whiteSpace=wrap;html=1;aspect=fixed;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"450\" y=\"340\" width=\"20\" height=\"20\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "2g2tDDkpjgB0YBOe56KS-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 36 L 36 0",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "2g2tDDkpjgB0YBOe56KS-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 36 L 36 72",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "2g2tDDkpjgB0YBOe56KS-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 108 36 L 72 0",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "2g2tDDkpjgB0YBOe56KS-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 108 36 L 72 72",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "2g2tDDkpjgB0YBOe56KS-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 9,
    rx: 9,
    ry: 9,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 0.9,
    pointerEvents: "all",
    style: {
      fill: "var(--ge-dark-color, #121212)",
      stroke: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "2g2tDDkpjgB0YBOe56KS-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 36,
    rx: 9,
    ry: 9,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 0.9,
    pointerEvents: "all",
    style: {
      fill: "var(--ge-dark-color, #121212)",
      stroke: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "2g2tDDkpjgB0YBOe56KS-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 63,
    rx: 9,
    ry: 9,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 0.9,
    pointerEvents: "all",
    style: {
      fill: "var(--ge-dark-color, #121212)",
      stroke: "rgb(255, 255, 255)"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminals);
export default __webpack_public_path__ + "static/media/terminals.0f9c566bce2130a23f59d6344e96f262.svg";
export { ForwardRef as ReactComponent };